<template>
  <div class="flex items-center justify-end leading-none text-xs">
    <div class="rounded-full bg-gray-300" :class="width">
      <div class="rounded-full bg-blue-300" :style="style">
        <span
          v-text="progress + '%'"
          class="leading-snug- text-black ml-3"
        ></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    progress: {
      required: true,
    },
    width: {
      type: String,
      required: false,
      default: "w-32",
    },
  },
  components: {},
  mixins: [],
  data: function () {
    return {};
  },
  methods: {},
  computed: {
    style() {
      let p = this.progress;
      if (p > 0 && p < 9) {
        p = 9;
      }
      return "width: " + p + "%;";
    },
  },
  mounted() {},
};
</script>

<style></style>
